// @flow
import React from 'react';
import type { Node } from 'react';
import { productColor, illustrationColor } from '../designSystem.js';
import { usePrintMode } from '../jsx-activity/usePrintMode.js';
// design assure us that this is the way all collapsibles should look,
// and the way all chevrons should behave.
// however this is the only instance of them working like this in
// jsx-content, so...
// in the future if this collapsible component is truly universal
// then it should be lifted up into the body of the repo

export function EngageNoteCollapsibleInternal(props: {|
  title: Node,
  icon?: Node,
  children: Node,
|}) {
  const cellStyle = {
    display: 'table-cell',
    verticalAlign: 'middle',
    textAlign: 'left',
  };
  const [_open, setIsOpen] = React.useState(false);
  const printMode = usePrintMode();
  const isOpen = printMode || _open;

  return (
    <div
      style={{
        backgroundColor: productColor.aliceBlue,
        borderRadius: 8,
        overflow: 'hidden',
        margin: '8px 0',
        marginBottom: 12,
        breakInside: 'avoid',
      }}
    >
      <div
        style={{
          display: 'table',
          tableLayout: 'fixed',
          width: '100%',
          cursor: 'pointer',
          height: 60,
        }}
        onMouseDown={(e) => {
          e.preventDefault();
          setIsOpen((o) => !o);
        }}
      >
        <div style={{ width: 20 + 4, ...cellStyle }} />
        {/* As the only cell without width, this will fill space */}
        <div style={cellStyle}>
          <div style={{ padding: '16px 0', ...cellStyle }}>{props.icon}</div>
          <div
            style={{
              padding: '16px 0',
              fontWeight: 600,
              verticalAlign: 'middle',
              color: productColor.cloudburst,
              ...cellStyle,
            }}
          >
            {props.title}
          </div>
        </div>
        <div style={{ width: 4, ...cellStyle }} />
        <div
          style={{
            width: 20 * 2 + 4 * 2,
            userSelect: 'none',
            padding: '16px 8px',
            ...cellStyle,
          }}
        >
          <UnfoldIcon variant={isOpen ? 'less' : 'more'} />
        </div>
      </div>
      <div
        style={{
          display: isOpen ? 'table' : 'none',
          tableLayout: 'fixed',
          width: '100%',
          padding: '24px 0px',
          backgroundColor: productColor.aliceBlue,
        }}
      >
        <div style={{ width: 20 + 4, ...cellStyle }} />
        {/* As the only cell without width, this will fill space */}
        <div style={cellStyle}>{props.children}</div>
        <div style={{ width: 20 + 4, ...cellStyle }} />
      </div>
    </div>
  );
}

function UnfoldIcon() {
  return (
    <svg
      width="12"
      height="7.5"
      viewBox="0 0 8 5"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M3.60957 4.51196L0.649878 0.812348C0.387973 0.484966 0.621059 0 1.04031 0H6.95969C7.37894 0 7.61203 0.484966 7.35012 0.812348L4.39043 4.51196C4.19027 4.76216 3.80973 4.76216 3.60957 4.51196Z"
        fill={illustrationColor.cloudburst}
      />
    </svg>
  );
}
